import projects from '../../content/projects.json'

export function loadProjects() {
  return projects
}

export function getProjectBySlug(slug) {
  return projects.find((project) => project.slug === slug) ?? null
}
